import { UserAdhesionDetailsI } from '../api/users/interfaces/UserAdhesionDetailsI';

/**
 * Conjunto (deduplicado) de CPSIs `product_code` de un plan, a partir de las adhesiones
 * que devuelve `getAdhesionDetails(mode)`. Un plan puede abarcar varios CPSIs (fondos
 * ACC+BON), por eso es un array. Se pasa a `getCalculatorsUserAportations` / `getUserCostBasis`
 * para que el backend filtre las aportaciones/base de coste por plan (multi-cuenta).
 *
 * Si no hay adhesiones (o CPSIs válidos) devuelve `[]` → el backend lee legacy (sin filtro
 * de plan), fallback seguro.
 *
 * 🔴 Comprueba que sea una LISTA, no solo que exista: comparsa responde 200 también a los
 * errores, con el código dentro del cuerpo, y cuando Caser falla `data` es un objeto. El
 * `.map` reventaba y la vista se quedaba en blanco sin llegar a pedir los movimientos
 * (DEV, 14/10/2026).
 */
export const getPlanProductCodes = (adhesionDetails?: UserAdhesionDetailsI[] | null): number[] =>
	Array.from(
		new Set(
			(Array.isArray(adhesionDetails) ? adhesionDetails : [])
				.map((adhesion) => adhesion.productCode)
				.filter((code): code is number => typeof code === 'number' && code > 0)
		)
	);
